export { default as addFavorite } from './addFavorite';
export { default as fetchDeviceDetection } from './fetchDeviceDetection';
export { default as fetchDiscounts } from './fetchDiscounts';
export { default as fetchFavorites } from './fetchFavorites';
export { default as fetchUserProfile } from './fetchUserProfile';
export { default as removeFavorite } from './removeFavorite';
